module.exports = __webpack_public_path__ + "static/media/dfc4afbf-ccfb-494f-9ee0-8bc445d7bea7.8bea79ec.eot";


//////////////////
// WEBPACK FOOTER
// ./src/Fonts/dfc4afbf-ccfb-494f-9ee0-8bc445d7bea7.eot
// module id = 73
// module chunks = 0